import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import { usePage } from "@inertiajs/vue3";

export const cioanalytics = new AnalyticsBrowser();

export function initCustomerIO(siteKey) {
    if (!siteKey || usePage().props.environment === "local") return;
    cioanalytics.load({
        cdnURL: "https://cdp-eu.customer.io",
        writeKey: siteKey,
    });
}

export default function (app) {
    app.config.globalProperties.$cioanalytics = cioanalytics;
    return app;
}
